import AutocompleteFormik from "@/common/components/form/AutocompleteFormik";
import { createDebounce } from "@/common/helpers/debounce.helper";
import { getSuitableRenter } from "@/common/services/loans.api";
import { useFormikContext } from "formik";
import { useEffect, useState } from "react";


const getSuitableRenters = createDebounce(getSuitableRenter, 100)

export type RenterSuitable = {
  renterName: string;
  renterId: string;
  cpf: string;
};

export function SuitableRenter() {
  const { setFieldValue } = useFormikContext();

  const [options, setOptions] = useState<{ label: string; value: string }[]>([]);

  const loadSuitableRenters = async () => {
    const result = await getSuitableRenters() as { ok: boolean, data: RenterSuitable[] };

    const options = result.data.map((item) => ({
      ...item,
      label: `${item.renterName} | ${item.cpf}`, value: item.renterId,

    }));
    setOptions(options);
    return options;
  };

  useEffect(() => {
    const fetchOptions = async () => {
      await loadSuitableRenters();
      setFieldValue("renterInfo", null);
    };
    fetchOptions();    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AutocompleteFormik
      name="renterInfo"
      label="Nome do locatário:"
      options={options}
    />
  );
}
